import styled from 'styled-components';
import { variables } from '@splunk/themes';

const Separator = styled.div.attrs(() => ({
    'data-test': 'separator',
}))`
    border-bottom: 1px solid ${variables.borderColor};
`;

export default Separator;
